import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

// "?" icon that opens a short explanation on tap/click (works on touch and desktop).
// Keeps screens light: one-line label inline, fuller explanation on demand.
export const InfoTip = ({ title, children, side = 'top', align = 'start', testId, className = '', size = 'sm' }) => {
  const iconCls = size === 'xs' ? 'w-3 h-3' : 'w-3.5 h-3.5';
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={title ? `More about ${title}` : 'More information'}
          data-testid={testId || 'info-tip'}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center justify-center align-middle rounded-full text-slate-400 hover:text-[#283F8B] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#108981] transition-colors ${className}`}
        >
          <HelpCircle className={iconCls} aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent side={side} align={align} className="w-72 p-3 text-left shadow-lg" onClick={(e) => e.stopPropagation()}>
        {title && <p className="text-xs font-semibold text-slate-800 mb-1">{title}</p>}
        <div className="text-xs text-slate-600 leading-relaxed space-y-1 [&_ul]:list-disc [&_ul]:pl-4 [&_ul]:space-y-0.5 [&_strong]:text-slate-800">
          {children}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default InfoTip;
